// This file was automatically generated from print.rxDownloadSummary.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.rxDownloadSummary');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print');
goog.require('el8.template.ptdata.medOrderFills');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.rxDownloadSummary.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageBreak pageWrap">');
  el8.template.print.header(opt_data, output);
  output.append('<h1 class="documentTitle">Summary of Medication Fills Downloaded</h1>');
  el8.template.print.patientDemog(opt_data, output);
  output.append('<div class="spacer"></div><table class="patientReports"><tr class="reportHeader"><th class="w49 cell">Medication</th><th class="w12 cell">Fill Date</th><th class="w8 cell">Qty</th><th class="w12 cell">Supply</th><th class="w25 cell">Prescriber</th></tr>');
  var fList17233 = opt_data.summary.downloadedFills;
  var fListLen17233 = fList17233.length;
  for (var fIndex17233 = 0; fIndex17233 < fListLen17233; fIndex17233++) {
    var fData17233 = fList17233[fIndex17233];
    el8.template.print.rxDownloadSummary.fill(fData17233, output);
  }
  output.append('</table></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.rxDownloadSummary.fill = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<tr><td class="w49 cell">', soy.$$escapeHtml(opt_data.medicationDescription), '</td><td class="w12 alignCenter cell">', (soy.$$escapeHtml(opt_data.lastFillDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.lastFillDate)) : ''), '</td><td class="w8 alignCenter cell">');
  if (opt_data.quantity) {
    output.append('#');
    el8.template.ptdata.medOrderFills.displayQuantity(opt_data, output);
  }
  output.append('</td><td class="w12 alignCenter cell">', soy.$$escapeHtml(opt_data.daysSupply ? opt_data.daysSupply + ' days' : ''), '</td><td class="w25 alignCenter cell">', soy.$$escapeHtml(opt_data.prescriber ? ' by ' + opt_data.prescriber : ''), '</td></tr>');
  if (!opt_sb) return output.toString();
};
